import PropTypes from 'prop-types'
import { memo, useMemo, useRef, useState } from 'react'
import BorderHighlight from 'components/elements/BorderHighlight/BorderHighlight'
import usePressEvents from 'lib/react/hooks/usePressEvents'
import { isTouch } from 'lib/support'
import classNames from 'lib/util/classNames'
import styles from './Item.module.scss'

/**
 * The `Item`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function Item (props) {
  const { Tag, children, className, isActive, ...rest } = props
  const ref = useRef()
  const isPressing = usePressEvents(ref)
  const [isHover, setIsHover] = useState(false)
  const classNameOutput = useMemo(
    () =>
      classNames([
        styles.item,
        className,
        isActive && styles.active,
        isPressing && styles.pressed
      ]),
    [className, isActive, isPressing]
  )

  return (
    <li>
      <Tag
        ref={ref}
        className={classNameOutput}
        {...rest}
        onMouseEnter={() => {
          !isTouch && setIsHover(true)
        }}
        onMouseLeave={() => {
          !isTouch && setIsHover(false)
        }}
      >
        <div className={styles.bg} />
        <BorderHighlight
          className={styles.borderHighlight}
          isActive={isHover}
        />
        <span>{children}</span>
      </Tag>
    </li>
  )
}

/** @type {object} */
Item.propTypes = {
  children: PropTypes.node,
  Tag: PropTypes.elementType,
  className: PropTypes.string,
  isActive: PropTypes.bool
}

/** @type {object} */
Item.defaultProps = {
  children: null,
  Tag: 'a',
  className: '',
  isActive: false
}

// Memoize
export default memo(Item)
